import React from 'react';
import '../App.css';

const Coordinators = () => {
  return (
    <section id="coordinators" className="py-3">
      <div className="container-fluid" style={{ maxWidth: '1400px' }}>
        <div className="section-header text-center mb-3">
          <h2 className="section-title">The Captain's Council</h2>
        </div>
        <div className="row align-items-start">
          {/* HOD Section - Left Side */}
          <div className="col-md-4 text-center mb-4 mb-md-0">
            <div className="coordinator-card">
              <div className="coordinator-image-container">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/HOD.jpg`}
                  alt="Head of Department"
                  className="img-fluid"
                  style={{
                    width: '180px',
                    height: 'auto',
                    maxHeight: '250px',
                    objectFit: 'contain'
                  }}
                />
              </div>
              <h4>Dr. M Sridevi</h4>
              <h5>Head of Department</h5>
              <h5><a
                href={`tel:+91 9035358066`}
                className="text-decoration-none text-white-50"
              >
                <i className="bi bi-telephone-fill me-2"></i>
                 +91 90353 58066
              </a></h5>
            </div>
          </div>

          {/* Panel Members - Right Side */}
          <div className="col-md-8">
            <div className="row justify-content-center">
              <div className="col-md-5 text-center mb-4">
                <div className="coordinator-card">
                  <div className="coordinator-image-container">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/GVD.jpeg`}
                      alt="Panel Member 1"
                      className="img-fluid"
                      style={{
                        width: '180px',
                        height: 'auto',
                        maxHeight: '250px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                  <h4>Prof. Dwarakanath GV</h4>
                  <h5>Faculty Co-ordinator</h5>
                  <h5><a
                    href={`tel:+91 9916155597`}
                    className="text-decoration-none text-white-50"
                  >
                    <i className="bi bi-telephone-fill me-2"></i>
                    +91 99161 55597
                  </a></h5>
                </div>
              </div>
              <div className="col-md-5 text-center mb-4">
                <div className="coordinator-card">
                  <div className="coordinator-image-container">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/AK.jpeg`}
                      alt="Panel Member 2"
                      className="img-fluid"
                      style={{
                        width: '180px',
                        height: 'auto',
                        maxHeight: '250px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                  <h4>Prof. Ashwitha K</h4>
                  <h5>Faculty Co-ordinator</h5>
                  <h5><a
                    href={`tel:+91 9164884315`}
                    className="text-decoration-none text-white-50"
                  >
                    <i className="bi bi-telephone-fill me-2"></i>
                    +91 91648 84315
                  </a></h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Student Coordinators Section */}
        <div id="student-coordinators" className="row mt-4 justify-content-center">
          <div className="col-12 col-xl-10">
            <div className="section-header text-center mb-1">
              <h3 className="section-title">Student Coordinators</h3>
            </div>
          </div>

          <div className="row g-3 g-md-4 mb-3">
            {[
              { name: 'Anjan Kumar N', role: 'Head Co-ordinator', contact: '+91 7899864355', pic: 'Anjan' },
              { name: 'Shubhang Gangolli', role: 'Head Co-ordinator', contact: '+91 9164800703', pic: 'Shubhang' },
              { name: 'Manasa R', role: 'Head Co-ordinator', contact: '+91 8123304331', pic: 'Manasa' },
              { name: 'Priyadarshini P', role: 'Head Co-ordinator', contact: '+91 9008149792', pic: 'Priyadarshini' }
            ].map((coordinator, index) => (
              <div key={index} className="col-6 col-md-3">
                <div className="coordinator-card h-100">
                  <div className="coordinator-image-container">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/${coordinator.pic}.jpg`}
                      alt={`${coordinator.name} - ${coordinator.role}`}
                      className="img-fluid"
                    />
                  </div>
                  <h4>{coordinator.name}</h4>
                  <h5>{coordinator.role}</h5>
                  <h5><a
                    href={`tel:${coordinator.contact}`}
                    className="text-decoration-none text-white-50"
                  >
                    <i className="bi bi-telephone-fill me-2"></i>
                    {coordinator.contact}
                  </a></h5>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Coordinator Roles */}
          <div className="row g-3 g-md-4 mb-3">
            {[
              { name: 'Abhiram H N', role: 'Technical Head', contact: '+91 9113271872', pic: 'Abhiram' },
              { name: 'Srujan Bhat', role: 'Managerial Head', contact: '+91 6360023057', pic: 'Srujan' },
              { name: 'Jayanth', role: 'Decoration Head', contact: '+91 9738642020', pic: 'Jayanth' },
              { name: 'Om', role: 'Treasurer', contact: '+91 7203836286', pic: 'Om' }
            ].map((coordinator, index) => (
              <div key={index} className="col-6 col-md-3">
                <div className="coordinator-card h-100">
                  <div className="coordinator-image-container">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/${coordinator.pic}.jpg`}
                      alt={`${coordinator.name} - ${coordinator.role}`}
                      className="img-fluid"
                    />
                  </div>
                  <h4>{coordinator.name}</h4>
                  <h5>{coordinator.role}</h5>
                  <h5><a
                    href={`tel:${coordinator.contact}`}
                    className="text-decoration-none text-white-50"
                  >
                    <i className="bi bi-telephone-fill me-2"></i>
                    {coordinator.contact}
                  </a></h5>
                </div>
              </div>
            ))}
          </div>

          {/* Website Designer Card */}
          <div className="col-6 col-md-3">
            <div className="coordinator-card text-center h-100">
              <h5 className="mb-2" style={{ color: '#64f0ff' }}>Website Designed By:</h5>
              <div className="coordinator-image-container mx-auto mb-3">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/Nachiket.jpg`}
                  alt="Website Designer"
                  className="img-fluid"
                />
              </div>
              <h4>Nachiket Hegde</h4>
              <div className="d-flex justify-content-center gap-3 mt-2">
                <a href="tel:+919353154253" className="text-white-50">
                  <i className="bi bi-telephone-fill"></i>
                </a>
                <a href="mailto:nachihegde@gmail.com" className="text-white-50">
                  <i className="bi bi-envelope-fill"></i>
                </a>
                <a href="https://www.instagram.com/nachhi_hegde?igsh=MTE3OHM0N3ZzbjJreg==" target="_blank" rel="noopener noreferrer" className="text-white-50">
                  <i className="bi bi-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Coordinators;